
























































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';

import {IpTools} from '@/utils/IpTools';

import {BaseComponent} from '@/mixins/BaseComponent';
import {ProfileSettings} from '@/model/network/settings/ProfileSettings';
import cidr from 'is-cidr';
import {IpRoute} from '@/model/network/IpRoute';

class Subnet {
  constructor(
      public Address: string = '',
      public Gateway: string = '',
  ) {
  }
}

@Component({
  components: {},
})
export default class NetworkIpSettingsRoutesEditorSimple extends Mixins<BaseComponent>(BaseComponent) {

  private IpTools = IpTools;

  private MinMetric: number = 0;

  private MaxMetric: number = 10000;

  @Prop({default: false})
  private hideDefaultRoute?: boolean;

  private isDefaultRoute: boolean = false;

  private metric: any = null;
  private metricAdvanced: boolean = false;

  private subnets: Subnet[] = [];
  private subnetsAdvanced: boolean = false;

  private metricRule = [
    (value?: number) => value === undefined || !isNaN(value) || 'Not a number',
    (value?: number) => value === undefined || (value >= this.MinMetric && value <= this.MaxMetric) || `Not a valid metric (${this.MinMetric} - ${this.MaxMetric})`,
  ];

  private subnetRule = [
    (value?: string) => !!value || 'Required',
    (value?: string) => cidr(value ?? '') !== 0 || `Not a valid subnet. E.g. 192.168.1.0/24`,
  ];

  @Prop(Object)
  private settings!: ProfileSettings;

  private mounted() {
    this.loadFormData();
  }

  private loadFormData() {

    this.isDefaultRoute = !this.settings.IPv4.NeverDefault;

    if (this.settings.IPv4.RouteMetric === this.settings.IPv6.RouteMetric) {
      this.metric = this.settings.IPv4.RouteMetric;
    } else {
      this.metricAdvanced = true;
    }

    const subnets: Subnet[] = [];
    for (const route of this.settings.IPv4.Routes) {
      if (route.Metric !== undefined) {
        this.subnetsAdvanced = true;
        break;
      }

      subnets.push(new Subnet(`${route.Destination}/${route.Prefix}`, route.Gateway));
    }
    this.subnets = subnets;
  }

  private addSubnet() {
    this.subnets.push(new Subnet());
  }

  private eraseSubnet(index: number) {
    this.subnets.splice(index, 1);
  }

  public validate(): boolean {

    this.settings.IPv4.NeverDefault = !this.isDefaultRoute;
    this.settings.IPv6.NeverDefault = !this.isDefaultRoute;

    if (!this.metricAdvanced) {
      if (this.metric === null || this.metric === '' || isNaN(this.metric)) {
        this.settings.IPv4.RouteMetric = -1;
        this.settings.IPv6.RouteMetric = -1;
      } else {
        this.settings.IPv4.RouteMetric = this.metric;
        this.settings.IPv6.RouteMetric = this.metric;
      }
    }

    if (this.subnetsAdvanced) {
      return true;
    }

    let allSuccess = true;
    const ip4Routes: IpRoute[] = [];
    const ip6Routes: IpRoute[] = [];

    for (const subnet of this.subnets) {

      const version = cidr(subnet.Address);

      if (version === 0) {
        this.logger.warn('Not a valid CIDR address', subnet.Address);
        allSuccess = false;
        continue;
      }

      const route = new IpRoute({
        Destination: subnet.Address.split('/')[0],
        Prefix: +subnet.Address.split('/')[1],
        Gateway: subnet.Gateway,
      });

      switch (version) {
        case 4:
          ip4Routes.push(route);
          break;

        case 6:
          ip6Routes.push(route);
          break;
      }
    }

    this.settings.IPv4.Routes = ip4Routes;
    this.settings.IPv6.Routes = ip6Routes;

    return allSuccess;
  }
}
